import { EventInfoCombinedProps } from './types';

const usePresenter = (props: EventInfoCombinedProps): EventInfoCombinedProps => {
  return props;
};

export default usePresenter;
